import { createSelector } from '@ngrx/store';
import { handleActions } from 'redux-actions';
import { ActionsEnum, HideGlobalBanner, SetGlobalBanner } from './app.actions';
import { IGlobalBanner } from '../modules/shared/components/global-banner/global-banner.interface';

// entire app state interface
export interface IState {
  globalBanner: IGlobalBanner;
}

// initial state
export const initialState: IState = {
  globalBanner: null,
};

// reducer
const reducerFn = handleActions(
  {
    [ActionsEnum.SET_GLOBAL_BANNER]: function (
      state: IState,
      { payload }: SetGlobalBanner
    ): IState {
      return {
        ...state,
        globalBanner: payload,
      };
    },
    [ActionsEnum.HIDE_GLOBAL_BANNER]: function (
      state: IState,
      { payload }: HideGlobalBanner
    ): IState {
      let globalBanner = state.globalBanner;

      if (
        !payload ||
        (globalBanner && globalBanner.id && globalBanner.id === payload)
      ) {
        globalBanner = null;
      }

      return {
        ...state,
        globalBanner,
      };
    },
  } as any,
  initialState
);

export interface IReducers {
  app: any;
}

export const appReducer: IReducers = {
  app: reducer,
};

export function reducer(state: IState, action: any) {
  return reducerFn(state, action);
}

// selectors
const selectApp = (state: IReducers) => state.app;

export const getGlobalBanner = createSelector(
  selectApp,
  (state: IState) => state.globalBanner
);
